import { PropsWithChildren } from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { captureException } from "@sentry/react";
import useAuth from "../hooks/useAuth";

export default function ProtectedRoute({ children }: PropsWithChildren) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [search] = useSearchParams();

  const searchPlaceRef = search.get("placeRef");
  if (searchPlaceRef) {
    window.localStorage.setItem("placeRef", searchPlaceRef);
    window.localStorage.setItem("placeRefTimestamp", Date.now().toString());
  }

  const ref = search.get("ref");

  // Prevents flickering: Wait until authentication state is resolved
  if (loading) return <div>Loading...</div>;

  if (!user) {
    // Save the ref parameter for after login, then redirect to login
    if (ref) {
      try {
        window.localStorage.setItem("redirectAfterLogin", `/${ref}`);
      } catch (error) {
        captureException(error);
        console.error("Failed to save redirect path:", error);
      }
      return <Navigate to="/login" />;
    }
    return (
      <Navigate to={location.pathname === "/redeem" ? "/login?r=redeem" : "/login"} />
    );
  }

  return <>{children}</>;
}
